import { PatientOverview } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function getBusinessPatientOverview({
  business_id,
  patientId,
  includeCompletedPackage,
}: {
  business_id: string;
  patientId: string;
  includeCompletedPackage?: boolean;
}): Promise<PatientOverview> {
  const headers = new Headers();

  headers.append("accept", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    headers,
    credentials: "include",
  };

  const TRYST_HOST = GET_TRYST_HOST();
  let url = `${TRYST_HOST}/business/${business_id}/patient/${patientId}/overview`;

  if (includeCompletedPackage) {
    url += `?include_completed_package=${includeCompletedPackage}`;
  }

  const response = await fetch(url, requestOptions);

  const data: TrystGenericResponse<PatientOverview> = await response.json();
  const { success, data: patientOverview } = data;
  if (success && patientOverview) {
    return patientOverview;
  }
  return {} as PatientOverview;
}
